// Blocked storage (private mode, browser policy) gives the fallback instead of throwing.
export const withStorage = <T>(fallback: T, use: () => T): T => {
  try {
    return use();
  } catch {
    return fallback;
  }
};

/** Sets `key` unless it is already set; true only for the call that set it. Blocked storage says no. */
export const takeOnce = (key: string, value: string, storage?: Storage): boolean =>
  withStorage(false, () => {
    const store = storage ?? sessionStorage;
    if (store.getItem(key)) return false;
    store.setItem(key, value);
    return true;
  });
